export default function validateEmail(v) {
  return !!/^[^@]+@[^@]+$/.test(`${v}`);
}
